function StoryboardConfigurationPage() {
    /**
     *
     */
    StoryboardConfigurationPage.prototype.initialize = function (console, storyboard) {
        this.id = "storyboardConfiguration";
        this.console = console;

        if (storyboard) {
            this.storyboardId = storyboard.id;
            this.storyboard = this.console.consoleService.filterTransient(storyboard);

            Storyboard.bind(this.console.node, this.storyboard);
        }
        else {
            this.storyboard = Storyboard.create(this.console.node);
        }

        return this;
    };

    /**
     *
     */
    StoryboardConfigurationPage.prototype.show = function () {
        var deferred = $.Deferred();

        this.console.nodeConfigurationScope = 4;

        deferred.resolve();

        return deferred.promise();
    };

    /**
     *
     */
    StoryboardConfigurationPage.prototype.deleteStoryboardStep = function (storyboardStep) {
        this.console.openConfirmationDialog("You are going to delete a Storyboard Step. Please confirm.", function () {
            Utils.removeItemFromArray(this.storyboard.content.timeline, storyboardStep);
        }.bind(this));
    };

    /**
     *
     */
    StoryboardConfigurationPage.prototype.createStoryboard = function () {
        this.console.consoleService.createStoryboard(this.console.node, this.storyboard).done(function (node) {
            this.console.bindNode(node);
            this.console.popPage();
        }.bind(this)).fail(function (error) {
            console.error(error);
            this.console.openMessageDialog("Failed to add Storyboard.", "error");
        }.bind(this));
    };

    /**
     *
     */
    StoryboardConfigurationPage.prototype.updateStoryboard = function () {
        this.console.consoleService.updateStoryboard(this.console.node, this.storyboard).done(function (node) {
            this.console.bindNode(node);
            this.console.popPage();
        }.bind(this)).fail(function (error) {
            console.error(error);
            this.console.openMessageDialog("Failed to change Storyboard.", "error");
        }.bind(this));
    };

    /**
     *
     */
    StoryboardConfigurationPage.prototype.leave = function () {
    };
}
